import Button from "../ui/Button/Button";
import PageSectionCard from "../ui/Page/PageSectionCard";
import { guardianStatusPillClassName, scrollablePanelClassName } from "./constants";
import type { GuardianWorkspaceRequestSection } from "./types";

type GuardianRequestsPanelProps = {
  section: GuardianWorkspaceRequestSection;
};

const GuardianRequestsPanel = ({ section }: GuardianRequestsPanelProps) => {
  return (
    <PageSectionCard className="sm:rounded-[2rem]">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:items-start sm:justify-between sm:text-left">
        <div className="min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-myteengig-text-muted">{section.title}</p>
          <h2 className="mt-2 text-2xl font-semibold tracking-tight text-myteengig-text-primary">{section.subtitle}</h2>
        </div>
        <span className="rounded-full bg-myteengig-background px-3 py-1 text-sm font-medium text-myteengig-text-primary">
          {section.items.length} {section.items.length === 1 ? "request" : "requests"}
        </span>
      </div>

      {section.items.length === 0 ? (
        <div className="mt-6 rounded-2xl border border-dashed border-myteengig-border bg-myteengig-background px-5 py-6 text-sm text-myteengig-text-muted">
          {section.emptyMessage}
        </div>
      ) : (
        <div className={scrollablePanelClassName(section.items.length)}>
          {section.items.map((item) => (
            <article
              key={item.id}
              className="rounded-[1.5rem] border border-myteengig-border bg-[linear-gradient(180deg,_rgba(255,255,255,1),_rgba(234,248,255,0.7))] p-5"
            >
              <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:flex-wrap sm:items-start sm:justify-between sm:text-left">
                <div className="min-w-0">
                  <p className="text-lg font-semibold text-myteengig-text-primary">{item.name}</p>
                  <p className="mt-1 text-sm text-myteengig-text-muted">{item.email}</p>
                  {item.meta ? <p className="mt-3 text-sm text-myteengig-text-muted">{item.meta}</p> : null}
                  <p className="mt-3 text-xs uppercase tracking-[0.18em] text-myteengig-text-muted">{item.updatedLabel}</p>
                </div>
                <span className={`rounded-full border px-3 py-1 text-xs font-semibold ${guardianStatusPillClassName.PENDING}`}>
                  {item.statusLabel}
                </span>
              </div>

              {item.actions?.length ? (
                <div className="mt-5 flex flex-wrap justify-center gap-3 sm:justify-start">
                  {item.actions.map((action) => (
                    <Button
                      key={action.label}
                      variant={action.variant ?? "outline"}
                      disabled={action.disabled || action.pending}
                      onClick={action.onClick}
                    >
                      {action.pending ? "Saving..." : action.label}
                    </Button>
                  ))}
                </div>
              ) : null}
            </article>
          ))}
        </div>
      )}
    </PageSectionCard>
  );
};

export default GuardianRequestsPanel;
